var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTiersDarkIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_160690",
    "data-name": "Group 160690",
    transform: "translate(-176 -216)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160681",
    "data-name": "Group 160681",
    transform: "translate(176 216)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1342",
    "data-name": "Rectangle 1342",
    width: 18,
    height: 18,
    transform: "translate(0 0)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1343",
    "data-name": "Rectangle 1343",
    width: 9.341,
    height: 1.872,
    transform: "translate(2.678 10.034) rotate(36)",
    fill: "#adc7ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1344",
    "data-name": "Rectangle 1344",
    width: 9.341,
    height: 1.872,
    transform: "matrix(-0.809, 0.588, -0.588, -0.809, 16.533, 11.549)",
    fill: "#adc7ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_160680",
    "data-name": "Group 160680",
    transform: "translate(1.578 0.853)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160606",
    "data-name": "Group 160606"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_163",
    "data-name": "Ellipse 163",
    cx: 0.444,
    cy: 0.444,
    r: 0.444,
    transform: "translate(7.16 12.922)",
    fill: "#787f88"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1102",
    "data-name": "Path 1102",
    d: "M9.437,11.736,2.924,7.167a.636.636,0,0,1,0-1.113L9.437,1.485a1.487,1.487,0,0,1,1.582,0L17.54,6.054a.636.636,0,0,1,0,1.113l-6.521,4.569A1.487,1.487,0,0,1,9.437,11.736Z",
    transform: "translate(-2.571 -1.257)",
    fill: "#f49b31",
    stroke: "#165cf3",
    strokeWidth: 1.33
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1103",
    "data-name": "Path 1103",
    d: "M4.171,12.8,2.91,11.883a.649.649,0,0,1,0-1.113l1.3-.95",
    transform: "translate(-2.571 -3.156)",
    fill: "none",
    stroke: "#165cf3",
    strokeWidth: 1.33
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_28",
    "data-name": "Line 28",
    x1: 4.281,
    y1: 3.121,
    transform: "translate(1.6 9.646)",
    fill: "none",
    stroke: "#165cf3",
    strokeLinecap: "round",
    strokeWidth: 1.33
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1104",
    "data-name": "Path 1104",
    d: "M18.274,9.94l1.168.848a.649.649,0,0,1,0,1.113L13.9,15.949",
    transform: "translate(-4.46 -3.182)",
    fill: "none",
    stroke: "#165cf3",
    strokeLinecap: "round",
    strokeWidth: 1.33
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1105",
    "data-name": "Path 1105",
    d: "M16.342,13.54l1.176.825a.636.636,0,0,1,0,1.113L11,20.047a1.487,1.487,0,0,1-1.582,0L2.893,15.47a.636.636,0,0,1,0-1.113l1.054-.739",
    transform: "translate(-2.565 -3.98)",
    fill: "rgba(0,0,0,0)",
    stroke: "#165cf3",
    strokeWidth: 1.33
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiersDarkIcon);
export default __webpack_public_path__ + "static/media/tiers-dark-icon.213bbff0889c6d6e1086f31ae1161471.svg";
export { ForwardRef as ReactComponent };